module.exports = __webpack_public_path__ + "img/connect_wallet_button_text_web.36965432.png";